<template>
  <div class="exam">
    <div class="nuv">
      <a href="#" class="active">语音考核</a>
    </div>
    <div class="tips" v-if="eventName == null">
      <p>目前考核不存在或考核已经结束。</p>
    </div>
    <div class="tips" v-if="eventName == 'Wait'">
      <p>考核前请确认耳机耳麦都准备好，小助手已调试正确。</p>
      <p>待你考核前方还有{{ people }}位小伙伴，预计{{ time }}分钟。</p>
    </div>
    <div class="tips" v-if="eventName == 'Confirm'">
      <p>考核前请确认耳机耳麦都准备好，小助手已调试正确。</p>
      <p>下一位就是你考核，是否确认？</p>
      <p><el-button type="danger" @click="confirmExam()">确认考核</el-button></p>
      <p>如果不及时确认考核，将视为你放弃本次机会</p>
    </div>
    <div class="tips" v-if="eventName == 'WaitCall'">
      <p>考核前请确认耳机耳麦都准备好，小助手已调试正确。</p>
      <p>已确认考核，请等待屏幕出现外呼按钮时，进行外呼</p>
    </div>
    <div class="tips" v-if="eventName == 'StartCall'">
      <template v-if="isWait">
        <p>不要紧张，记得你平时所学习和保持和练习的一样。</p>
        <p>正在等待接通：{{ currCallTimeForSecond }}秒</p>
        <p><el-button type="danger" @click="endCall()">挂断</el-button></p>
      </template>
      <template v-else>
        <p>考核前请确认耳机耳麦都准备好，小助手已调试正确。</p>
        <p>考核中，请外呼电话</p>
        <p><el-button type="danger" @click="callClick()">外呼</el-button></p>
      </template>
    </div>
    <div class="tips" v-if="eventName == 'Call'">
      <p>不要紧张，记得你平时所学习和保持和练习的一样。</p>
      <p>电话已接通，请不要刷新和关闭当前考核页面！</p>
      <p>通话时长：{{ currCallingTimeForStr }}</p>
    </div>
    <div class="tips" v-if="eventName == 'CallEnd'">
      <p>考核完毕，请等待老师发布成绩，成绩将已通知的形式发送到你的APP！</p>
    </div>
    <div class="tips" v-if="eventName == 'Abandon'">
      <p>非常遗憾，你被视为放弃考核，请下次认真对待。</p>
    </div>
    <p v-if="!success" class="tj-shift-notice">{{ message }}</p>
    <template v-else>
      <h3>考核名单</h3>
      <p class="tj-shift-notice" v-if="!list.length">暂无记录！</p>
      <template v-else>
        <el-table :data="list" border style="width: 100%" :row-class-name="tableRowClassName">
          <el-table-column prop="examineSeq" label="顺序" width="180"></el-table-column>
          <el-table-column prop="realName" label="考核人员" width="180"></el-table-column>
          <el-table-column prop="tjkNumber" label="淘金号" width="180"></el-table-column>
          <el-table-column label="状态" width="180">
            <template slot-scope="scope">
              <template v-if="scope.row.examineState == 'Examining'">正在考核</template>
              <template v-if="scope.row.examineState == 'Examined'">已考核</template>
              <template v-if="scope.row.examineState == 'Wait'">待考核</template>
              <template v-if="scope.row.examineState == 'Abandon'">学员放弃</template>
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="考核开始时间"></el-table-column>
          <el-table-column prop="duration" label="考核时长"></el-table-column>
        </el-table>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      'success': true,
      'message': '',
      'groupId': this.$route.query.groupId,
      'people': '', //等待人数
      'time': '', //等待时间
      'eventName': '', //事件名称
      'eventData': '', //事件数据
      'phone': '', //外呼电话号码
      'tjkId': '', //当前淘金客ID
      'list': [], //待考核名单列表
      'interval': null, //轮询状态
      'refresh': '', //列表是否刷新
      //当前拨打电话等待时间定时器
      'callInterval': null,
      //当前拨打电话等待时间(秒)
      'currCallTimeForSecond': 0,
      //当前通话电话时间定时器
      'callingInterval': null,
      //当前通话电话时间(秒)
      'currCallingTimeForSecond': 0,
      'socketUrl': API_ROOT.wsUrl, //容联ws
      'hawkeyeSocketUrl': API_ROOT.hawkeyeUrl, //小助手
      //保存ws链接
      'connection': null,
      //ws是否连接
      'isopen': false,
      //是否通过小助手打电话
      'isHawkeyeCall': true,
      //WS重连次数
      'tryTime': 0,
      //小助手是否已提示升级
      'isAlert': false,
      //根据answer来判断是否接听端正忙
      'isAnswer': false,
      //等待接通电话标识
      'isWait': false,
      'merchantId': 387
    }
  },
  mounted: function() {
    this.init()
    this.intervalFun()
    this.getList()
  },
  watch: {
    refresh: function() {
      if(this.refresh == 'Yes') {
        this.getList()
      }
    }
  },
  computed: {
    // 通话时间00:00:00
    currCallingTimeForStr () {
      let h = parseInt(this.currCallingTimeForSecond / (60 * 60))
      let m = parseInt((this.currCallingTimeForSecond % (60 * 60)) / 60)
      let s = parseInt((this.currCallingTimeForSecond % (60 * 60)) % 60)
      return (h >= 10 ? h : '0' + h) + ':' + (m >= 10 ? m : '0' + m) + ':' + (s >= 10 ? s : '0' + s)
    }
  },
  methods: {
    hawkeyeAlert(msg) {
      this.$alert(msg, '系统提示', {
        confirmButtonText: '确定',
        callback: action => {
          window.location.href = "/tjkStudy/tjkExam?groupId="+this.groupId
        }
      })
    },
    myAlert(msg) {
      this.$alert(msg, '系统提示', {
        confirmButtonText: '确定',
        callback: action => {
          
        }
      })
    },
    //轮询代码
    intervalFun() {
      let self = this
      self.interval = setInterval(() => {
        console.log('this is interval...')
        self.init()
      }, 5000)
    },
    //轮询查询事件接口
    init() {
      var data = {
        'groupId': this.groupId
      }
      this.$http.post(API_ROOT.college + '/voice/examine/eventMsg', data).then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.eventName = result.data.eventName
          this.eventData = result.data.eventData
          if(this.eventName == 'StartCall') {
            this.phone = result.data.eventData.callPhone
          }
          this.refresh = result.data.eventData.refresh
        }else {
          this.myAlert(result.msg)
        }
      }, response => {
        this.myAlert('网络繁忙，请稍后重试！')
      })
    },
    //查询考核名单列表
    getList() {
      var data = {
        'groupId': this.groupId
      }
      this.$http.post(API_ROOT.college + '/voice/examine/tjkView', data).then(response => {
        var result = response.data
        this.successList = result.success
        this.message = result.msg
        if(result.success) {          
          this.list = result.data.list
          this.people = result.data.number
          this.time = result.data.duration
          for(var i=0;i<result.data.list.length;i++) {
            if(result.data.list[i].myself == 'Yes') {
              this.tjkId = result.data.list[i].tjkId
            }
          }
        }
      }, response => {
        this.myAlert('网络繁忙，请稍后重试！')
      })
    },
    //当前淘金客高亮
    tableRowClassName({row, rowIndex}) {
      if (row.myself == 'Yes') {
        return 'myself-row'
      }
      return ''
    },
    //确认考核
    confirmExam() {
      this.changeStatus('Confirmed')
    },
    //更新淘金客状态--确认考核
    changeStatus(status) {
      var data = {
        'groupId': this.groupId,
        'userState': status
      }
      this.$http.post(API_ROOT.college + '/voice/examine/updateUserState', data).then(response => {
        var result = response.data
        if(result.success) {
          this.init()
        }else {
          this.myAlert(result.msg)
        }
      }, response => {
        this.myAlert('网络繁忙，请稍后重试！')
      })
    },
    // 链接WS和小助手
    callClick() {
      if(this.isopen && this.isHawkeyeCall) {
        this.callPhone()
      }else {
        this.initWS()
      }
    },
    // 初始化websocket链接
    initWS() {
      var self = this,
        data = {
          'agent': self.tjkId,
          'code': 0
        }
      if (!window.WebSocket) {
        self.myAlert("您的浏览器版本过低，无法完成工作，请更换至谷歌或者IE10！")
        return false
      }
      console.log("WebSocket is supported by your Browser!")
      self.hawkeyeConnectionFunc('connect')
      if(!self.isopen) {
        self.connectionFunc(data)
      }
    },
    // 创建websocket链接
    connectionFunc(data) {
      var self = this
      self.connection = new WebSocket(self.socketUrl)
      self.connection.onopen = function() {
        console.log("Webpage web socket is connected")
        self.isopen = true
        self.connection.send(JSON.stringify(data))
      }
      self.connection.onmessage = function(result) {
        // console.log("Message is received...: " + result.data)
        var data = eval('(' + result.data + ')'),
          status = (data.code == "200"),
          msg = data.msg,
          rst = data.rst
        
        // 成功拨打返回，显示弹层 SIP应答
        if(msg == "calling") { self.afterCalling() }
        // 接听电话
        if(msg == "answer") {
          self.isAnswer = true
          self.afterAnswer() 
        }
        //挂断电话-未接听
        if(msg == 'sipOutCallEnd' && !self.isAnswer) {
          self.busyFun()
        }
        //挂断电话--已接听
        if(msg == 'sipOutCallEnd' && self.isAnswer) {
          self.isAnswer = false
          self.hangedUp() 
        }
        if(msg == "makecall_error") { 
          self.myAlert("拨打失败: " + rst.msg) 
        }
        // 预警
        if(msg == "warning") { 
          self.myAlert('温馨提示：' + rst.reason) 
        }  
      }
      self.connection.onclose = () => {
        console.log('Connection is closed...')
        self.isopen = false
        // 重试5次，每次之间间隔5秒
        if (self.tryTime < 5) {
          setTimeout(function () {
            self.connection = null
            self.tryTime++
            self.connectionFunc({'agent': self.tjkId, 'code': 0})
            console.log("第"+self.tryTime+"次重连")
          }, 5000)
        } else {
          self.alert("webSocket重连失败")
        }
      }
      self.connection.onerror = () => {
        self.isopen = false
        console.log('Connection is error.')
      }
    },
    hawkeyeConnectionFunc: function(data) {
      var self = this
      self.hawkeyeConnection = new WebSocket(self.hawkeyeSocketUrl)
      self.hawkeyeConnection.onopen = function() {
        self.isHawkeyeCall = true
        console.log("Hawkeye web socket is connected")
        self.hawkeyeConnection.send(data)
      }
      self.hawkeyeConnection.onmessage = function(result) {
        console.log("Hawkeye message is received...: " + result.data)
        if(result.data == 0) {
          self.myAlert("小助手已离线，请重启小助手后刷新当前页面！")
          return
        }
        if(result.data == 'Success') {
          //拨号
          self.callPhone()
        }
        if(result.data == 'GetSipAccountFailure') {
          self.hawkeyeAlert("获取SIP账号失败，请稍候再重新外呼！")
          return
        }
        if(result.data == 'NoMic') {
          self.hawkeyeAlert("请先插入麦克风和耳机！")
          return
        }
        if(result.data == 'InitSipFailure') {
          self.hawkeyeAlert("初始化SIP电话发生异常，请稍候再重新外呼！")
          return
        }
      }
      self.hawkeyeConnection.onclose = function() {
        console.log("Hawkeye connection is closed...")
        self.isHawkeyeCall = false
        if(!self.isAlert) {
          self.isAlert = true
          self.myAlert('请检查是否是新版小助手且开启！')
        }
      }
      self.hawkeyeConnection.onerror = function() {
        console.log("Hawkeye connection is error.")
        self.isHawkeyeCall = false
        if(!self.isAlert) {
          self.isAlert = true
          self.myAlert('请检查是否是新版小助手且开启！')
        }
      }
    },
    // 开始拨打电话
    callPhone() {
      if(this.isHawkeyeCall) {
        this.hawkeyeConnection.send('call|' + this.phone + ',' + 0 + ',' + 0)
        this.isWait = true
        this.callInterval = setInterval(() => {
          this.currCallTimeForSecond++
        }, 1000)
        console.log('拨号中...')
      }else {
        this.myAlert('请检查是否是新版小助手且开启！')
      }
    },
    //对方忙的情况下主动挂断电话
    endCall() {
      this.hawkeyeConnectionFunc('hangup')
      console.log('主动挂断电话..')
      this.currCallTimeForSecond = 0
      clearInterval(this.callInterval)
      this.isWait = false
    },
    // busy状态的回调-淘金客状态变成重新开始外呼
    busyFun() {
      this.currCallTimeForSecond = 0
      clearInterval(this.callInterval)
    },
    // SIP点击了应答-等待接通
    afterCalling() {},
    //电话接通
    afterAnswer() {
      let self = this
      self.isWait = false
      self.currCallTimeForSecond = 0
      clearInterval(self.callInterval)
      // 当前接通电话时间为0
      self.currCallingTimeForSecond = 0
      // 开始通话计时并且显示通话界面
      self.callingInterval = setInterval(() => {
        self.currCallingTimeForSecond++
      }, 1000)
      //淘金客状态变为通话中
      self.changeStatus('Call')
      console.log('电话接通...')
    },
    // 挂断
    hangedUp() {
      let self = this
      // 清空通话定时器和时间
      self.currCallingTimeForSecond = 0
      clearInterval(self.callingInterval)
      //淘金客状态变为通话结束
      self.changeStatus('Callend')
      self.hawkeyeConnectionFunc('hangup')
      console.log('小助手hangup..')
      console.log('挂断..')
    }
  }
}
</script>
<style type="less" scoped>
  .tips {
    background-color: #3b3b62;
    text-align: center;
    font-size: 18px;
    color: #ffffff;
    margin-bottom: 20px;
  }
  .tips p {
    padding: 5px 0;
  }
</style>


// WEBPACK FOOTER //
// ./src/page/college/tjkExam.vue